let DesktopMenu = () => {
  let elements = {
    desktopNavLinks: Array.from(document.querySelectorAll(".nav-bar-main.sk-desktop li")),
    dropdownNav: document.querySelector(".desktop-nav-dropdown"),
    bg: document.querySelector(".desktop-nav-dropdown .dropdown-bg"),
    allPages: Array.from(document.querySelectorAll(".desktop-nav-dropdown .dropdown-page")),
    activeLink: undefined,
  }

  let timeouts = {
    showDropdown: undefined,
    hideDropdown: undefined,
    startHideDropdown: undefined,
  };

  let durations = {
    showDropdown: 10,
    hideDropdown: 210,
    startHideDropdown: 100,
  };

  // Functions
  /**
   * - Initializes desktop menu
   */
  function Init() {
    // Events
    elements.desktopNavLinks.forEach(link => {
      link.addEventListener("mouseenter", ShowDropdown);
      link.addEventListener("mouseleave", StartHideDropdown);
    });

    elements.dropdownNav.addEventListener("mouseenter", ShowDropdown);
    elements.dropdownNav.addEventListener("mouseleave", StartHideDropdown);

    window.addEventListener("resize", AnimateSyncHeight);
  }

  /**
   * - Clears all timeouts
   */
  function ClearAllTimeouts() {
    // Clear timeouts
    if (timeouts.showDropdown) clearTimeout(timeouts.showDropdown);
    if (timeouts.hideDropdown) clearTimeout(timeouts.hideDropdown);
    if (timeouts.startHideDropdown) clearTimeout(timeouts.startHideDropdown);
  }

  /**
   * - Syncs height to content size
   */
  function SyncHeight() {
    let activePage = document.querySelector(".dropdown-page.active");
    if (activePage) elements.bg.style.height = `${activePage.clientHeight}px`;
  }

  /**
   * - Starts animation for syncing height
   */
  function AnimateSyncHeight() {
    setTimeout(() => {
      window.requestAnimationFrame(SyncHeight);
    }, 10);
  }

  /**
   * - Starts the process of hiding the nav dropdown
   */
  function StartHideDropdown() {
    ClearAllTimeouts();
    timeouts.startHideDropdown = setTimeout(HideDropdown, durations.startHideDropdown);
  }

  /**
   * - Shows dropdown
   */
  function ShowDropdown(e = undefined) {
    ClearAllTimeouts();

    // Check if hovering over nav
    let hoveredElem = e.currentTarget;
    let hoveringNav = hoveredElem.classList.contains("desktop-nav-dropdown");

    if (!hoveringNav) {
      // Check if a page exists for hovered element
      let hoveredTitle = hoveredElem.getAttribute("data-val");
      let matchingPage = document.querySelector(`.desktop-nav-dropdown .dropdown-page[data-page='${hoveredTitle}']`);

      if (!matchingPage) {
        HideDropdown();
        return;
      };

      // Show matching page and hide all other ones
      elements.allPages.forEach(page => page.classList.remove("active"));
      matchingPage.classList.add("active");

      // Set active for hovered elem and set inactive to all other ones
      elements.desktopNavLinks.forEach(link => link.classList.remove("active"));
      elements.activeLink = hoveredElem;
      elements.activeLink.classList.add("active");
    }

    // Enable
    elements.dropdownNav.classList.remove("sk-hidden");
    elements.bg.style.opacity = "1";

    // Set Active
    timeouts.showDropdown = setTimeout(() => {
      elements.dropdownNav.classList.add("active");

      AnimateSyncHeight();
    }, durations.showDropdown);
  }

  /**
   * - Hides dropdown
   */
  function HideDropdown() {
    ClearAllTimeouts();

    // Enable
    elements.dropdownNav.classList.remove("active");
    AnimateSyncHeight();

    // Set Active
    timeouts.hideDropdown = setTimeout(() => {
      AnimateSyncHeight();
      elements.dropdownNav.classList.add("sk-hidden");
      elements.bg.style.opacity = "0";

      if (elements.activeLink) elements.activeLink.classList.remove("active");
      elements.activeLink = undefined;
    }, durations.hideDropdown);
  }

  Init();

  return Object.freeze({
    ShowDropdown,
    HideDropdown,
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    DesktopMenu = DesktopMenu();
  });
} else {
  DesktopMenu = DesktopMenu();
}
